

























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import FileSelectModal from "@/components/files/modals/FileSelectModal.vue";
import SelectStockImageModal from "@/components/files/modals/SelectStockImageModal.vue";
import BehaviorDropdown from "@/components/posts/BehaviorDropdown.vue";
import DirectFileUploadControl from "@/components/common/files/DirectFileUploadControl.vue";
// types
import { BehaviorEnum } from "@/services/posts/types";
import { ImageIPostProperties, ImagePostSettings } from "@/services/posts/postTypes/image";
import { FILEENDPOINT } from "@/app.config";
import { MediaType } from "@/services/files/types";
import i18n from "@/i18n";
import { ValidationModel } from "@/services/validation/types";
import { FolderEntites } from "@/services/folders/types";
import { Getter } from "vuex-class";
import { getFileFolderEntity } from "@/services/files/fileService";

const namespace: string = "authentication";

@Component({
    components: {
        DirectFileUploadControl,
        FileSelectModal,
        BehaviorDropdown,
        SelectStockImageModal
    }
})
export default class ImageForm extends Vue {
    @Getter("getUserHasFolderAccess", { namespace }) getUserHasFolderAccess!: boolean;
    @Getter("getAllowStockImages") allowStockImages!: boolean;
    @Prop() private properties!: ImageIPostProperties;
    @Prop() private channelHeight!: number;
    @Prop() private channelWidth!: number;
    @Prop() postSettings!: ImagePostSettings;

    ratio = 1;
    factor = 1;
    allowDrag = false;
    allowResize = false;
    originalFileName = "" as string;
    fileFolderEntity = FolderEntites.Files as FolderEntites;

    containerSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0
    };

    imageSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0,
        cropSizeWidth: 0,
        cropSizeHeight: 0
    };

    dragPosition = {
        x: 0,
        y: 0,
        initialX: 0,
        initialY: 0,
        initialCropPosition: 0,
        resizeX: 0,
        resizeY: 0,
        resizeWidth: 0,
        resizeHeight: 0
    }

    img = {
        width: 0,
        height: 0
    };

    // local state
    localProperties = { path: "", name: "", behavior: "" as BehaviorEnum } as ImageIPostProperties;
    type = MediaType.Image;
    behaviorTypes: any = Object.keys(BehaviorEnum)
        .map(key => ({ name: i18n.t(`posts.${key}`), id: key }));

    validators = {
        behavior: {
            active: null
        } as unknown as ValidationModel,
        image: {
            active: null
        } as unknown as ValidationModel
    };

    folders = FolderEntites;
    // lifecycle hooks
    created() {
        this.localProperties.behavior = "adjust" as BehaviorEnum;
    }

    @Watch("localProperties.behavior", { immediate: true }) localPropWatch() {
        this.calcLetterbox();
    }

    async mounted() {
        if (this.properties && this.properties.path) {
            this.localProperties = this.properties;
            this.loadImage();
            this.fileFolderEntity = await getFileFolderEntity(this.properties.path);
        } else {
            this.$nextTick(() => {
                this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
            });
        }
        document.addEventListener("mousemove", this.resize);
        document.addEventListener("mousedown", this.resizeStart);
        document.addEventListener("mouseup", this.resizeEnd);

        document.addEventListener("mousemove", this.drag);
        document.addEventListener("mousedown", this.dragStart);
        document.addEventListener("mouseup", this.dragEnd);
    }

    destroyed() {
        document.removeEventListener("mousemove", this.resize);
        document.removeEventListener("mousedown", this.resizeStart);
        document.removeEventListener("mouseup", this.resizeEnd);
        document.removeEventListener("mousemove", this.drag);
        document.removeEventListener("mousedown", this.dragStart);
        document.removeEventListener("mouseup", this.dragEnd);
    }

    // computed
    get imageUrl(): string {
        return `${FILEENDPOINT}${this.localProperties.path}`;
    }

    get behaviorValid(): boolean {
        return this.localProperties.behavior.length > 0;
    }

    get imageValid(): boolean {
        return this.localProperties.path.length > 0;
    }

    get cropStyle() {
        return `
            width: ${this.imageSize.cropSizeWidth}px;
            height: ${this.imageSize.cropSizeHeight}px;
            top: ${this.dragPosition.y}px;
            left: ${this.dragPosition.x}px;
        `;
    }

    // methods
    openFileSelect() {
        if (this.fileFolderEntity === FolderEntites.Files && this.getUserHasFolderAccess) {
            (this.$refs.fileSelectModal as any).open(this.localProperties.path);
        } else if (this.fileFolderEntity === FolderEntites.StockFiles && this.allowStockImages) {
            (this.$refs.selectStockImageModal as any).open();
        } else {
            (this.$refs.directFileUploadControl as any).openFileUpload();
        }
    }

    openStockImageSelect() {
        (this.$refs.selectStockImageModal as any).open();
    }

    removeImage() {
        this.fileFolderEntity = FolderEntites.Files;
        this.localProperties.path = "";
        this.localProperties.name = "";

        this.toggleHeaderButtons(true);
    }

    loadImage() {
        const image = new Image();
        image.onload = () => {
            this.img.width = image.width;
            this.img.height = image.height;
            this.calcAspectRatio(this.channelWidth, this.channelHeight, 500, 500, image.width, image.height);
            this.calcLetterbox();
        };

        image.src = this.imageUrl;
    }

    onSelect(file: any) {
        this.$set(this.localProperties, "path", file.fileId);
        this.$set(this.localProperties, "name", file.name);
        this.setItemName();
        this.loadImage();
        this.fileFolderEntity = FolderEntites.Files;
        this.$bvModal.hide("modal-fileSelect");
    }

    onDirectFileUploaded(file: any) {
        this.$set(this.localProperties, "path", file.fileId);
        this.$set(this.localProperties, "name", file.originalFileName);
        this.originalFileName = file.originalFileName;
        this.setItemName();
        this.loadImage();
        this.fileFolderEntity = FolderEntites.DirectFiles;
    }

    onStockFileUploaded(file: any) {
        this.$set(this.localProperties, "path", file.fileId);
        this.$set(this.localProperties, "name", file.originalFileName);
        this.originalFileName = file.originalFileName;
        this.setItemName();
        this.loadImage();
        this.fileFolderEntity = FolderEntites.StockFiles;
    }

    uploadStarted() {
        this.localProperties.path = "";
        this.localProperties.name = "";
    }

    calcAspectRatio(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number, imgWidth: number, imgHeight: number) {
        let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        if (ratio > 1) ratio = 1;

        const calc = { width: srcWidth * ratio, height: srcHeight * ratio, ratio };
        this.containerSize.width = calc.width;
        this.containerSize.height = calc.height;
        this.containerSize.origWidth = calc.width;
        this.containerSize.origHeight = calc.height;
        this.imageSize.width = imgWidth * calc.ratio;
        this.imageSize.height = imgHeight * calc.ratio;
        this.imageSize.origWidth = imgWidth * calc.ratio;
        this.imageSize.origHeight = imgHeight * calc.ratio;
    }

    calcLetterbox() {
        if (this.localProperties.behavior !== undefined) {
            if (this.localProperties.behavior === BehaviorEnum.adjust) {
                this.containerSize.width = 500;
                this.containerSize.height = 500;

                // Calculate how much to zoom the image (ratio) and how much to zoom the total package (crop & image) afterwards (factor)
                this.ratio = Math.max(this.channelWidth / this.img.width, this.channelHeight / this.img.height);
                const maxSize = Math.min(Math.max(this.channelWidth, this.channelHeight), 500);
                this.factor = Math.min(maxSize / (this.img.width * this.ratio), maxSize / (this.img.height * this.ratio));

                // Size the image and the crop according to the above calculations
                this.imageSize.width = this.img.width * this.factor;
                this.imageSize.height = this.img.height * this.factor;
                this.imageSize.cropSizeWidth = this.channelWidth * this.factor;
                this.imageSize.cropSizeHeight = this.channelHeight * this.factor;

                // We only restore the state of the crop square if the exact conditions are met:
                // The image must be the same, the position must exist, and the channel width and height must be unchanged
                if (this.localProperties.position && this.localProperties.position.id === this.localProperties.path && this.localProperties.position.channelWidth === this.channelWidth && this.localProperties.position.channelHeight === this.channelHeight) {
                    this.dragPosition.x = this.localProperties.position.editorX;
                    this.dragPosition.y = this.localProperties.position.editorY;
                    if (this.localProperties.position.cropSizeWidth && this.localProperties.position.cropSizeHeight) {
                        this.imageSize.cropSizeWidth = this.localProperties.position.cropSizeWidth;
                        this.imageSize.cropSizeHeight = this.localProperties.position.cropSizeHeight;
                    }
                } else {
                    // Otherwise just center the crop square
                    this.dragPosition.x = Math.ceil(((this.imageSize.width * this.ratio) - this.imageSize.cropSizeWidth) / 2) || 0;
                    this.dragPosition.y = Math.ceil(((this.imageSize.height * this.ratio) - this.imageSize.cropSizeHeight) / 2) || 0;
                }
            } else if (this.localProperties.behavior === BehaviorEnum.crop) {
                this.imageSize.width = this.imageSize.origWidth;
                this.imageSize.height = this.imageSize.origHeight;
                this.containerSize.width = this.containerSize.origWidth;
                this.containerSize.height = this.containerSize.origHeight;

                if (this.imageSize.origWidth > this.containerSize.width && this.imageSize.origHeight > this.containerSize.height) {
                    this.imageSize.width = this.containerSize.width;
                    this.imageSize.height = this.containerSize.height;
                }
            } else if (this.localProperties.behavior === BehaviorEnum.letterBox) {
                this.containerSize.width = this.containerSize.origWidth;
                this.containerSize.height = this.containerSize.origHeight;
                if (this.imageSize.origWidth > this.containerSize.width || this.imageSize.origHeight > this.containerSize.height) {
                    const ratio = Math.min(this.containerSize.width / this.imageSize.origWidth, this.containerSize.height / this.imageSize.origHeight);
                    this.imageSize.width = this.imageSize.origWidth * ratio;
                    this.imageSize.height = this.imageSize.origHeight * ratio;
                }
            } else {
                this.containerSize.width = this.containerSize.origWidth;
                this.containerSize.height = this.containerSize.origHeight;
                this.imageSize.width = this.imageSize.origWidth;
                this.imageSize.height = this.imageSize.origHeight;
            }
        }
    }

    validateData() {
        this.validators.behavior.active = true;
        this.validators.image.active = true;
        return this.behaviorValid && this.imageValid;
    }

    emitData() {
        this.localProperties.position = {
            id: this.localProperties.path,
            x: this.dragPosition.x === 0 ? 0 : this.dragPosition.x / this.factor,
            y: this.dragPosition.y === 0 ? 0 : this.dragPosition.y / this.factor,
            editorX: this.dragPosition.x,
            editorY: this.dragPosition.y,
            cropSizeWidth: this.imageSize.cropSizeWidth ? this.imageSize.cropSizeWidth : null,
            cropSizeHeight: this.imageSize.cropSizeHeight ? this.imageSize.cropSizeHeight : null,
            factor: this.factor ? this.factor : null,
            channelWidth: this.channelWidth,
            channelHeight: this.channelHeight,
            imgWidth: 0,
            imgHeight: 0
        };

        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        const name =
            this.localProperties.caption ||
            this.originalFileName.substring(0, this.originalFileName.lastIndexOf(".")) ||
            this.localProperties.name.substring(0, this.localProperties.name.lastIndexOf("."));
        this.$emit("itemNameUpdated", name);
    }

    toggleHeaderButtons(state: boolean) {
        this.$emit("toggleHeaderButtons", state);
    }

    dragStart(e: any) {
        if (!e.target.classList.contains("crop-square")) return;
        if ((this.imageSize.width * this.ratio) <= this.imageSize.cropSizeWidth && (this.imageSize.height * this.ratio) <= this.imageSize.cropSizeHeight) return;
        this.allowDrag = true;
        this.dragPosition.initialX = e.clientX;
        this.dragPosition.initialY = e.clientY;
    }

    dragEnd() {
        if (!this.allowDrag) return;
        this.allowDrag = false;
    }

    drag(e: any) {
        if (this.allowResize) {
            this.allowDrag = false;
            return;
        }
        if (!this.allowDrag) return;
        e.preventDefault();
        const cropSquare = (this.$refs.cropsquare as any);
        const pos1 = this.dragPosition.initialX - e.clientX;
        const pos2 = this.dragPosition.initialY - e.clientY;
        this.dragPosition.initialX = e.clientX;
        this.dragPosition.initialY = e.clientY;
        let newPos1 = cropSquare.offsetLeft - pos1;
        let newPos2 = cropSquare.offsetTop - pos2;

        // Prevent from dragging the crop box out of image bounds
        if (newPos2 < 0) newPos2 = 0;
        if (newPos1 <= 0) newPos1 = 0;
        if (newPos1 >= (this.imageSize.width * this.ratio) - this.imageSize.cropSizeWidth) newPos1 = Math.round((this.imageSize.width * this.ratio) - this.imageSize.cropSizeWidth);
        if (newPos2 >= (this.imageSize.height * this.ratio) - this.imageSize.cropSizeHeight) newPos2 = Math.round((this.imageSize.height * this.ratio) - this.imageSize.cropSizeHeight);

        this.dragPosition.x = newPos1;
        this.dragPosition.y = newPos2;
    }

    resizeStart(e: any) {
        if (!e.target.classList.contains("crop-resize") && !e.target.parentNode.classList.contains("crop-resize")) return;
        this.allowResize = true;
        this.dragPosition.resizeX = e.clientX;
        this.dragPosition.resizeY = e.clientY;
        this.dragPosition.resizeWidth = this.imageSize.cropSizeWidth;
        this.dragPosition.resizeHeight = this.imageSize.cropSizeHeight;
    }

    resizeEnd() {
        if (!this.allowResize) return;
        this.allowResize = false;
    }

    resize(e: any) {
        if (!this.allowResize) return;
        e.preventDefault();
        const minWidth = 50;
        const cropRatio = (this.dragPosition.resizeHeight / this.dragPosition.resizeWidth);
        const width = this.dragPosition.resizeX - e.clientX;
        let newWidth = this.dragPosition.resizeWidth - width;
        let newHeight = (this.dragPosition.resizeWidth - width) * cropRatio;
        // Don't allow resize to be smaller than minWidth
        if (this.dragPosition.resizeWidth - width <= minWidth) {
            newWidth = minWidth;
            newHeight = minWidth * cropRatio;
        }

        // Don't allow resize to go out of the image bounds
        if ((Math.ceil((newWidth + this.dragPosition.x)) > Math.ceil((this.imageSize.width * this.ratio)))) {
            const maxWidth = Math.ceil(this.imageSize.width * this.ratio) - this.dragPosition.x;
            newWidth = maxWidth;
            newHeight = maxWidth * cropRatio;
        }

        if ((Math.ceil((newHeight + this.dragPosition.y)) > Math.ceil((this.imageSize.height * this.ratio)))) {
            const maxHeight2 = Math.ceil(this.imageSize.height * this.ratio) - this.dragPosition.y;
            newWidth = maxHeight2 * (this.dragPosition.resizeWidth / this.dragPosition.resizeHeight);
            newHeight = maxHeight2;
        }

        this.imageSize.cropSizeWidth = newWidth;
        this.imageSize.cropSizeHeight = newHeight;
    }
}
